import { NgClass, NgFor, TitleCasePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { HlTestCategory } from '@models/hl-test-category';
import { HealthLabsOrderService } from '@services/healthlabs-order.service';
import { OrderService } from '@services/order.service';

@Component({
  selector: 'app-find-tests-modal',
  templateUrl: './find-tests-modal.component.html',
  styleUrls: ['./find-tests-modal.component.scss'],
  imports: [NgClass, NgFor, TitleCasePipe],
})
export class FindTestsModalComponent implements OnInit {
  public testCategories: HlTestCategory[] = [];

  private orderService = inject(OrderService);

  /**
   * Get modal display state
   */
  public get shouldDisplayModal(): boolean {
    return (this.orderService as HealthLabsOrderService).findTestsModalState;
  }

  public ngOnInit(): void {
    this.healthlabsTestCategories();
  }

  /**
   * Toggle find tests modal display state
   *
   * @param {boolean} status The modal display state
   */
  public toggleFindTestsModal(status: boolean): void {
    (this.orderService as HealthLabsOrderService).findTestsModalState = status;
  }

  /**
   * Redirect to Healthlabs search page
   *
   * @param {string} searchTerm The search term
   */
  public onSearch(searchTerm: string): void {
    window.location.href = `${environment.siteUrls.tests}/search?searchQuery=${encodeURIComponent(searchTerm)}`;
  }

  /**
   * Get healthlabs test categories
   */
  private healthlabsTestCategories(): void {
    (this.orderService as HealthLabsOrderService).getTestCategories().subscribe((response) => {
      this.testCategories = response.sort((a, b) => a.name.localeCompare(b.name));
    });
  }
}
